export const SEARCH_ASSETS = 'search/SEARCH_ASSETS'
export const SET_ASSETS_RESULTS = 'search/SET_ASSETS_RESULTS'
export const SET_IS_SEARCHING = 'search/SET_IS_SEARCHING'
